export default __webpack_public_path__ + "static/media/008-taxi.a37691e3.svg";